import img10k from "@/assets/img/premios/rifa365-10k.png";
import img50k from "@/assets/img/premios/rifa365-50k.png";
import img100k from "@/assets/img/premios/rifa365-100k.png";
import img250k from "@/assets/img/premios/rifa365-250k.png";
import img500k from "@/assets/img/premios/rifa365-500k.png";
import img1M from "@/assets/img/premios/rifa365-1M.png";
import img5M from "@/assets/img/premios/rifa365-5M.png";
import img10M from "@/assets/img/premios/rifa365-10M.png";

export const PREMIACOES_TIERS = [
  {
    id: "start",
    ticket: "10K",
    name: "Start",
    description: "Primeiros passos rumo ao sucesso.",
    threshold: 10000,
    image: img10k,
  },
  {
    id: "bronze",
    ticket: "50K",
    name: "Bronze",
    description: "Sua jornada começou. Continue crescendo.",
    threshold: 50000,
    image: img50k,
  },
  {
    id: "silver",
    ticket: "100K",
    name: "Silver",
    description: "Você já está entre os destaques.",
    threshold: 100000,
    image: img100k,
  },
  {
    id: "gold",
    ticket: "250K",
    name: "Gold",
    description: "Resultados consistentes geram grandes conquistas.",
    threshold: 250000,
    image: img250k,
  },
  {
    id: "diamond",
    ticket: "500K",
    name: "Diamond",
    description: "Um verdadeiro destaque da plataforma.",
    threshold: 500000,
    image: img500k,
  },
  {
    id: "elite",
    ticket: "1M",
    name: "Elite",
    description: "Mais de R$ 1 milhão movimentados.",
    threshold: 1000000,
    image: img1M,
  },
  {
    id: "legend",
    ticket: "5M",
    name: "Legend",
    description: "Apenas poucos chegam até aqui.",
    threshold: 5000000,
    image: img5M,
  },
  {
    id: "hall",
    ticket: "10M",
    name: "Hall of Fame",
    description: "O nível máximo da Rifa365.",
    threshold: 10000000,
    image: img10M,
  },
];

/** WhatsApp da equipe Rifa365 para solicitação de placas físicas. */
export const PREMIACOES_TEAM_WHATSAPP = "5562996363892";

export function getHighestTier(lifetimeRevenue) {
  const revenue = Number(lifetimeRevenue) || 0;
  let current = null;
  for (const tier of PREMIACOES_TIERS) {
    if (revenue >= tier.threshold) current = tier;
  }
  return current;
}

export function buildSolicitarPlacaWhatsAppUrl(userName, tier) {
  if (!tier) return null;
  const nome = String(userName || "cliente").trim() || "cliente";
  const message =
    `Olá! Sou *${nome}*. Já alcancei a placa *${tier.name} (${tier.ticket})* na Rifa365 e quero solicitar o envio da minha placa personalizada.`;
  return `https://wa.me/${PREMIACOES_TEAM_WHATSAPP}?text=${encodeURIComponent(message)}`;
}

export function buildAdminParabensPlacaWhatsAppUrl(userPhone, userName, tierLabel) {
  const digits = String(userPhone || "").replace(/\D/g, "");
  if (!digits) return null;
  const nome = String(userName || "").trim() || "cliente";
  const tier = String(tierLabel || "Start (10K)").trim();
  const message =
    `Olá *${nome}*! Aqui é Lucas da equipe Rifa365. Vi que você já alcançou a placa *${tier}* — quer receber a sua placa personalizada?`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}
export function formatMoneyBrl(value) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(Number(value) || 0);
}

/**
 * @param {number} lifetimeRevenue
 * @returns {{
 *   revenue: number,
 *   current: object|null,
 *   next: object|null,
 *   remaining: number,
 *   progressPct: number,
 *   tiers: Array<object>
 * }}
 */
export function getPremiacoesProgress(lifetimeRevenue) {
  const revenue = Number(lifetimeRevenue) || 0;
  let current = null;
  let next = null;

  for (const tier of PREMIACOES_TIERS) {
    if (revenue >= tier.threshold) {
      current = tier;
    } else if (!next) {
      next = tier;
    }
  }

  const start = current ? current.threshold : 0;
  const target = next ? next.threshold : current ? current.threshold : PREMIACOES_TIERS[0].threshold;
  const span = Math.max(target - start, 1);
  const progressPct = next
    ? Math.min(100, Math.max(0, ((revenue - start) / span) * 100))
    : 100;
  const remaining = next ? Math.max(0, next.threshold - revenue) : 0;

  const tiers = PREMIACOES_TIERS.map((tier) => {
    let status = "locked";
    if (revenue >= tier.threshold) {
      status = current && current.id === tier.id ? "current" : "unlocked";
    } else if (next && next.id === tier.id) {
      status = "next";
    }
    return { ...tier, status };
  });

  // If highest unlocked exists but we mark all unlocked as unlocked except last current
  if (current && !next) {
    return {
      revenue,
      current,
      next: null,
      remaining: 0,
      progressPct: 100,
      tiers: PREMIACOES_TIERS.map((tier) => ({
        ...tier,
        status: tier.id === current.id ? "current" : "unlocked",
      })),
    };
  }

  return {
    revenue,
    current,
    next,
    remaining,
    progressPct,
    tiers,
  };
}
